







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DevExpress from 'devextreme/bundles/dx.all';
import SelectedValues from '../types';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { localize } from '@/core/filters';

@Component({
    components: {
        DxColumn,
        DxDataGrid
    }
})
export default class CustomItem extends Vue {
    @Prop({ type: Array, required: true }) public values!: SelectedValues[];

    private get localize() {
        return localize;
    }

    private get tableConfig() {
        return {
            showBorders: false,
            filterRow: {
                visible: false,
            }
        };
    }
}
